(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8686],{

/***/ 5699:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password/reset",
      function () {
        return __webpack_require__(63286);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);
/* harmony import */ var modules_Login_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73194);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33892);



var useCachedIdentifier = function(form) {
    var mounted = (0,hooks__WEBPACK_IMPORTED_MODULE_1__/* .useMounted */ .s4)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (mounted) {
            var ref;
            form.setValues({
                identifier: (ref = sessionStorage.getItem(modules_Login_constants__WEBPACK_IMPORTED_MODULE_2__/* .LOGIN_IDENTIFIER */ .B)) !== null && ref !== void 0 ? ref : ""
            });
        }
    }, [
        mounted
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useCachedIdentifier);


/***/ }),

/***/ 73194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LOGIN_IDENTIFIER; }
/* harmony export */ });
var LOGIN_IDENTIFIER = "hx_login_identifier";


/***/ }),

/***/ 33624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var next_translate_Trans__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65895);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29718);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95660);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68711);






var Footer = function(param) {
    var _align = param.align, align = _align === void 0 ? "center" : _align;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
        size: "sm",
        align: align,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            i18nKey: "user:signupHasAccount",
            components: {
                component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_3__/* .AnchorLink */ .PN, {
                    href: config_constants__WEBPACK_IMPORTED_MODULE_4__/* .Login */ .m3
                })
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 63286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ password_reset; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Center/Center.js + 1 modules
var Center = __webpack_require__(91004);
// EXTERNAL MODULE: ./src/components/site/index.ts + 21 modules
var site = __webpack_require__(24613);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(17192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.6.0/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(33481);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var next_router = __webpack_require__(73654);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(65895);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./src/utils/index.ts + 8 modules
var utils = __webpack_require__(73046);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/FormProvider/FormProvider.js
var FormProvider = __webpack_require__(33313);
;// CONCATENATED MODULE: ./src/modules/Password/Reset/formContext.ts


var ref = (0,_sliced_to_array/* default */.Z)((0,FormProvider/* createFormContext */.W)(), 3);
var PasswordResetFormProvider = ref[0], usePasswordResetFormContext = ref[1], usePasswordResetForm = ref[2];

// EXTERNAL MODULE: ./src/components/business/index.ts + 206 modules
var business = __webpack_require__(91404);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./src/modules/Signup/Form/Footer.tsx
var Footer = __webpack_require__(33624);
// EXTERNAL MODULE: ./src/components/business/hooks/useCachedIdentifier.ts
var useCachedIdentifier = __webpack_require__(90706);
;// CONCATENATED MODULE: ./src/modules/Password/Reset/Form/index.tsx

















var ResetForm = function() {
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* default */.Z)("pagePwdReset").t;
    var resetFormValidate = (0,business/* useFormValidations */.$5)().resetFormValidate;
    var form = usePasswordResetForm({
        initialValues: {
            identifier: "",
            password: "",
            confirmPassword: "",
            captcha: ""
        },
        validateInputOnBlur: [
            "identifier"
        ],
        validate: function(values) {
            return resetFormValidate(values, form);
        }
    });
    (0,useCachedIdentifier/* default */.Z)(form);
    var submitButtonDisabled = !form.values.identifier || !form.isValid("identifier") || !form.values.password || !form.values.captcha || !form.values.confirmPassword;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useRetrievePasswordMutation */.kao)(), 2), retrievePasswordMutation = ref[0], ref1 = ref[1], submitting = ref1.loading;
    var handlePasswordReset = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var hasErrors, identifier, password, captcha, data, err, graphQLErrors;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hasErrors = form.validate().hasErrors;
                        if (hasErrors) {
                            return [
                                2
                            ];
                        }
                        identifier = values.identifier, password = values.password, captcha = values.captcha;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            retrievePasswordMutation({
                                variables: {
                                    input: {
                                        identifier: identifier.trim(),
                                        password: password,
                                        captcha: captcha
                                    }
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        if (!(data === null || data === void 0 ? void 0 : data.retrievePassword)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            router.replace(constants/* Login */.m3)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        err = _state.sent();
                        graphQLErrors = err.graphQLErrors;
                        (0,utils/* graphqlErrorCatch */.Qf)({
                            graphQLErrors: graphQLErrors,
                            mapping: new Map([
                                [
                                    "error.mismatched",
                                    t("user:authentication.form.errors.captchaMismatched")
                                ]
                            ]),
                            defaultMessage: t("errors.default")
                        });
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePasswordReset(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var identifierNotExistedErrorHandler = function() {
        var identifier = form.values.identifier;
        var message = /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
            i18nKey: "pagePwdReset:errors.identifierNotExisted",
            components: {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                    href: constants/* Signup */.Al
                })
            }
        });
        form.setFieldError("identifier", message);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordResetFormProvider, {
        form: form,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            className: "h-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                spacing: "2xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                        order: 2,
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                        spacing: "xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* IdentifierInput */.Ud, {
                                size: "md",
                                required: true,
                                formContext: form
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* CaptchaCodeSendAndInput */.wk, {
                                captchaType: domain/* CaptchaType.RetrievePassword */.$IZ.RetrievePassword,
                                form: form,
                                identifierNotExistedErrorHandler: identifierNotExistedErrorHandler
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* PasswordInputStep */.H9, {
                                form: form
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                size: "md",
                                fullWidth: true,
                                loading: submitting,
                                disabled: submitButtonDisabled,
                                onClick: function() {
                                    return handlePasswordReset(form.values);
                                },
                                children: t("title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                                align: "left"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Form = (ResetForm);

;// CONCATENATED MODULE: ./src/pages/password/reset.tsx






var Reset = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
        h: "100%",
        align: "center",
        justify: "space-between",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
            h: "100%",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* SessionPaper */.vD, {
                noBorder: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {})
            })
        })
    });
};
Reset.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* SessionLayout */.bY, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ var password_reset = (Reset);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2525,3703,8329,1958,4476,7094,1404,3226,9774,2888,179], function() { return __webpack_exec__(5699); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);